var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"d-flex justify-space-between"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-btn',{staticClass:"closeButton",attrs:{"small":"","fab":"","depressed":""},on:{"click":_vm.closeModal}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }